module.exports = __webpack_public_path__ + "img/support.a3305759.svg";